import { Component, OnInit,ViewChild,ElementRef } from '@angular/core';
import {HttpserviceService} from '../common/services/httpservice.service';
import {retry} from 'rxjs/operators';
import { SessionsService } from '../common/services/sessions.service';
import { Router } from '@angular/router';
import {ConstantsService} from '../common/services/constants.service';
import {UtilsService} from '../common/services/utils.service';
import { FormGroup,FormControl,Validators } from '@angular/forms';
import * as $ from 'jquery';
declare var reset_slider: Function;
declare var reset_slider3: Function;
declare var show_okshan_alert: Function;
declare var show_okshan_alert3: Function;
declare var hide_modal: Function;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']  
})
export class HomeComponent implements OnInit {

  carAutionTypeBit:number=2;
  carListAuction; 
  carFixedPriceTypeBit:number=1;
  carListFixedPrice;
  fileUrl;
  actionStatus:boolean=false;
  sessionId:number=0;
  sessionProfileType:number=-1;
  sessionStatus:number=-1;
  carId:number=0;
  brandList=[];
  ModelList=[{"id":"","name":"Choose make first"}];
  brandModelList=[];
  bodyTypetList=[];
  brandList2=[];
  brandList3=[];
  testimonialList=[];
  okshanDetailList=[];
  timerList=[];

  bidFormGroup;
  isSubmitBid:boolean=false;
  bidBTNLabel:string='Save';

  bidSecurityAmount:any=0;
  minBidAmount:any=0;
  highestBidAmount:any=0;
  bidMsg:string='';
  
  @ViewChild('searchBrand') searchBrand: ElementRef;
  @ViewChild('searchModel') searchModel: ElementRef;
  @ViewChild('searchYearFromTo') searchYearFromTo: ElementRef;
  @ViewChild('searchSaleType') searchSaleType: ElementRef;

  constructor(
    private httpserviceService:HttpserviceService,
    private sessionsService:SessionsService,
    private router:Router,
    private _constant: ConstantsService,
    private utilsService:UtilsService
    ) { }

  ngOnInit(): void {
      if(this.sessionsService.getSession("login_status")==null)
    {       
         window.location.href="#/visitor";       
    }
    else if(!this.sessionsService.getSession("login_status"))
       {
         window.location.href="#/visitor";
       }
    window.scrollTo(0, 0); 
    setTimeout(() => {
    this.proceedAdminTestimonialListRequest();  
    }, 500);
  
   
 if(this.sessionsService.getSession("profile_type")!=null && this.sessionsService.getSession("status")!=null)
    {
       if(this.sessionsService.getSession("profile_type")!=-1 && this.sessionsService.getSession("status")==1)
       {
         this.actionStatus=true;
       }
    }
    if(this.sessionsService.getSession("id")!=null)
    {
       this.sessionId=this.sessionsService.getSession("id");
    }
   if(this.sessionsService.getSession("profile_type")!=null)
    {
       this.sessionProfileType=this.sessionsService.getSession("profile_type");
    }
    if(this.sessionsService.getSession("status")!=null)
    {
       this.sessionStatus=this.sessionsService.getSession("status");
    }
    if (this.sessionsService.getSession('brand_list') != null ) {
      this.brandList=this.sessionsService.getSession('brand_list');
      console.log(this.brandList);
    }
    this.fileUrl=this._constant.uploadFileUrl;
    this.getCarList(this.carAutionTypeBit);//type 1 fixed price and 2 auction
    this.getBrandModelList()
    this.getCarBodyType();
    this.getBrandList2();

    
this.bidFormGroup= new  FormGroup( 
      { 
      bidAmount: new FormControl("",[Validators.required]),      
      }
    );
  }

  /** getCarList function used to get car list  */
  getCarList(type)//type 1 fixed price and 2 auction
  {
    let result =this.httpserviceService.carListRequest(this.sessionsService.getSession("id"),type,"0","","","").
     pipe(retry(0)).
     subscribe((data)=>this.carListResponse(data,type),
     err => {
       show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
  }

  /** carListResponse function used to handle response */
  carListResponse(response,type)
  {
    console.log('carListResponse '+ response);
    if(response.status==="success")  
     {
       if(type==2)
       {
      this.carListAuction=response.list;
      this.setOkshanDetail();
      this.getCarList(this.carFixedPriceTypeBit);//type 1 fixed price and 2 auction

      setTimeout(() => {
        reset_slider('.owl-carousel-icons');
      }, 100);
      
       }
       else if(type==1)
       {
       this.carListFixedPrice=response.list;  
       setTimeout(() => {
        reset_slider('.owl-carousel-icons-fix');
      }, 100);
       }
     }
     else
     {
     show_okshan_alert(response.reason);
     } 
  }

  /** fixedPriceCars function used to get fixed price cars */
  fixedPriceCars()
  {
     this.router.navigate(['fixed-price-cars']);
  }

  /** auctionCars function used to get auction cars */
  auctionCars()
  {
     this.router.navigate(['auction-cars']);
  }

  /** auctionCarDetail function used to show auction detail */
  auctionCarDetail(id)
  {
    this.router.navigate(['auction-car-detail'], { queryParams: { id: id } });
  }

  /** fixedPriceCarDetail function used to show fixed price car detail */
  fixedPriceCarDetail(id)
  {
    this.router.navigate(['fixed-price-car-detail'], { queryParams: { id: id } });
  }

  /** getModelFromId function used to get model from id  */
   getModelFromId(id)
   {
     if(this.sessionsService.getSession('all_model_list')==null)
     {
       return "";
     }
     let List=this.sessionsService.getSession('all_model_list');     
     if(List.length==0)
     {
       return "";
     } 
     return List[id];
   }

   /** getVariantFromId function used to get variant from id  */
   getVariantFromId(id)
   {     
     if(this.sessionsService.getSession('all_variant_list')==null)
     {
       return "";
     }
     let List=this.sessionsService.getSession('all_variant_list');         
     if(List.length==0)
     {
       return "";
     } 
     return List[id];
   }

   
/** getBrandModelList function used to get brand model list */ 
  getBrandModelList()
  { 
    let result =this.httpserviceService.getBrandModelListRequest().
     pipe(retry(0)).
     subscribe((data)=>this.getBrandModelListResponse(data),
     err => {
      //  this.isRequestInprocess=false; 
      //  show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })  
  }  

  /** getBrandModelListResponse function used to handle response */
  getBrandModelListResponse(response)
  {    
    console.log('getBrandModelListResponse '+ response.status);
    if(response.status==="success")  
     { 
       this.brandModelList=response.list;     
     }
     else
     {
     show_okshan_alert(response.reason);     
     } 
  }

   /** getModelListFromId function used to get model from id  */
   getModelListFromId(id)
   { 
     if(this.brandModelList!=null && id>0)
     {       
     this.ModelList=this.brandModelList[id];    
     }
   }

   /** search function used to search from home page */
   search()
   {
     if(this.searchBrand.nativeElement.value!="" || this.searchModel.nativeElement.value!="" || this.searchYearFromTo.nativeElement.innerHTML.indexOf("Year Range")<0)
     {
     this.utilsService.homeSearch={
       "brand":this.searchBrand.nativeElement.value,
       "model":this.searchModel.nativeElement.value,
       "year_from_to":this.searchYearFromTo.nativeElement.innerHTML,
       "brand_model_list":this.brandModelList
       }
     
     if(this.searchSaleType.nativeElement.value==1)
     {
       this.router.navigate(['fixed-price-cars']);
     }
     else if(this.searchSaleType.nativeElement.value==2 || this.searchSaleType.nativeElement.value==0)
     {
       this.router.navigate(['auction-cars']);
     }
     }
   }

   /** show alert msg */
   show_msg(msg)
   {     
     if(msg=="profile completion")
     {
       if(this.sessionProfileType==-1)
       {
         show_okshan_alert("Complete registration for more detail");
       }
       else if(this.sessionStatus!=1)
       {
         show_okshan_alert("Your profile is under approval");
       }
       else if(this.sessionProfileType==1)
       {
         show_okshan_alert("This feature is not authorized for you");
       } 
     }
    else
    { 
    show_okshan_alert(msg);
    }
   }
    
  sellCar()
  {
     this.router.navigate(['sell-car']);
  }  

  /** getCarBodyType function used to get car body type list */ 
  getCarBodyType()
  { 
    let result =this.httpserviceService.getCarBodyTypeRequest().
     pipe(retry(0)).
     subscribe((data)=>this.getCarBodyTypeResponse(data),
     err => {
      //  this.isRequestInprocess=false; 
        show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })  
  }  

  /** getCarBodyTypeResponse function used to handle response */
  getCarBodyTypeResponse(response)
  {    
    console.log('getBrandWithCountResponse '+ response.status);
    if(response.status==="success")  
     { 
       this.bodyTypetList=response.list; 
     }         
     else
     {
     show_okshan_alert(response.reason);     
     } 
  }

  /** onBodyTypeSelect function used to perform event on body type click */
  onBodyTypeSelect(id)
  {
    this.utilsService.homeBodyType={
      "id":id
    }
    this.router.navigate(['auction-cars']);
  }

  /** getBrandList2 function used to get brand list */ 
  getBrandList2()
  { 
    let result =this.httpserviceService.getBrandListRequest2().
     pipe(retry(0)).
     subscribe((data)=>this.getBrandListResponse2(data),
     err => {
      //  this.isRequestInprocess=false; 
        show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })  
  }  

  /** getCarBodyTypeResponse function used to handle response */
  getBrandListResponse2(response)
  {    
    console.log('getBrandWithCountResponse '+ response.status);
    if(response.status==="success")  
     { 
       let list=response.list;
       //this.brandList2=response.list; 
       for(let m=0;m<list.length;m++)
       {
        if(m<15)
        {
        this.brandList2.push(list[m]);
        }
        else
        {
        this.brandList3.push(list[m]);
        }
       } 
     }         
     else
     {
     show_okshan_alert(response.reason);     
     } 
  }

  /** onSelectBrand function used to perform operation on select brand */
  onSelectBrand(id)
  {
    this.utilsService.homeBrandType={
      "id":id
    }
    this.router.navigate(['auction-cars']);
  }

  /** proceedAdminTestimonialListRequest function used to get testimonial list */ 
  proceedAdminTestimonialListRequest()
  { 
    let result =this.httpserviceService.adminTestimonialListRequest().
     pipe(retry(0)).
     subscribe((data)=>this.adminTestimonialListResponse(data),
     err => {
      //  this.isRequestInprocess=false; 
        show_okshan_alert("Something went wrong !");
       console.log('Something went wrong ', err);       
    })  
  }  

  /** adminTestimonialListResponse function used to handle response */
  adminTestimonialListResponse(response)
  {    
    console.log('getBrandWithCountResponse '+ response.status);
    if(response.status==="success")  
     { 
      this.testimonialList=response.list; 
      setTimeout(() => {
       reset_slider3('.owl-carousel-assoc-fix'); 
      }, 200);      
     }
     else
     {
     show_okshan_alert(response.reason);     
     } 
  }

  setOkshanDetail()
  {
    for(let m=0;m<this.carListAuction.length;m++)
    {
      let item=this.carListAuction[m];
      if(item)
      {
       if(item.okshan_date && item.okshan_time && item.okshan_end_date && item.okshan_end_time)
       {
         if(item.okshan_date!="" && item.okshan_time!="" && item.okshan_end_date!="" && item.okshan_end_time!="")
            {
              let startAt = new Date(item.okshan_date+" "+item.okshan_time); 
              let endAt = new Date(item.okshan_end_date+" "+item.okshan_end_time);              
              this.okshanDetailList.push({"id":item.id,"startAt":startAt,"endAt":endAt});
            }
       }
       this.carListAuction[m]=item;
       this.timerList[item.id]={};
      }      
    }
               setInterval(() => {
                this.setOkshanTimer(); 
                let dateNow = new Date();
                }, 1000);
  }

  setOkshanTimer()
  {
     for(let m=0;m<this.okshanDetailList.length;m++)
     {
      if(this.okshanDetailList[m].startAt && this.okshanDetailList[m].endAt) 
      {    
      let okshanDetail={};  
      let dateNow:any = new Date();
      let startAt:any=new Date(this.okshanDetailList[m].startAt)
      let endAt=new Date(this.okshanDetailList[m].endAt)
      if(dateNow>=startAt && dateNow<=endAt)
      {
      okshanDetail["status"]="live";
      }
      else if(dateNow<startAt)
      {
      okshanDetail["status"]="comming";
      let okshanStartIn="";      
      let seconds = Math.floor((startAt - (dateNow))/1000);
      let minutes = Math.floor(seconds/60);
      let hours = Math.floor(minutes/60);
      let days = Math.floor(hours/24);

      hours = hours-(days*24);
      minutes = minutes-(days*24*60)-(hours*60);
      seconds = seconds-(days*24*60*60)-(hours*60*60)-(minutes*60);
       
      if(days>0) 
      {
      if(days==1)
      {
      okshanStartIn="Starts In Day "+days+" "+hours+":"+minutes+":"+seconds;
      }
      else
      {
      okshanStartIn="Starts In Days "+days+" "+hours+":"+minutes+":"+seconds;
      }
      }
      else 
      {
      okshanStartIn="Starts In "+hours+":"+minutes+":"+seconds;
      }
      okshanDetail["startsIn"]=okshanStartIn;      
      }
      this.timerList[this.okshanDetailList[m].id]=okshanDetail;
       }
     }
  }

  /** setHighestBid function used to set highest bid */
  setHighestBid(highestBidAmount,minimumBidAmount,id)
  {
    this.highestBidAmount=highestBidAmount;
    this.minBidAmount=minimumBidAmount;
    this.carId=id;
  }

  /** saveBid function used to save okshan bid */
  saveBid(data)
  {
   this.bidMsg="";
   this.isSubmitBid=true;
   if(this.bidFormGroup.valid)
   {
    if(this.highestBidAmount!='')
    {
      if(parseInt(data.bidAmount)<=parseInt(this.highestBidAmount))
      {
        this.bidMsg="Bid amount must more than highest bid amount";
        return false;
      }
      else
      {  
      this.router.navigate(['payment']);
      }
    }
    else if(this.minBidAmount!='')
    {
      if(parseInt(data.bidAmount)<=parseInt(this.minBidAmount))
      {
        this.bidMsg="Bid amount must more than minimum bid amount";
        return false;
      }
      else
      {  
      // let detail={"ev":"bid","amt": data.bidAmount,"sec":this.bidSecurityAmount,"car_id":this.carId};
      // let requestData=btoa(JSON.stringify(detail));
      // this.router.navigate(['payment'], { queryParams: { qzwp: requestData } });
      let body={profile_id: this.sessionsService.getSession('id'), car_id:this.carId , bid_amount:data.bidAmount, reserve_amount:this.bidSecurityAmount}
     let result =this.httpserviceService.saveBidDetailRequest(body).
     pipe(retry(0)).
     subscribe((data)=>this.saveBidDetailResponse(data), 
     err => {
       show_okshan_alert3("Something went wrong !");
       console.log('Something went wrong ', err);       
    })
      }
    }    
   }
  }

  /** saveBidDetailResponse method used to handle response */
  saveBidDetailResponse(response)
  {
    console.log('saveBidDetailResponse '+ response.status);
    if(response.status==="success")  
     {
       hide_modal('bid_now_modal');
       show_okshan_alert3("Detail is saved");       
     }
     else
     {
     show_okshan_alert3(response.reason);     
     } 
  }
}
